import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleIcon from "@mui/icons-material/AddCircle";

const PreviuosEmployementHistory = ({ newdata, setNewdata }) => {
  const preemphistory = newdata?.preemphistory || [];

  /* ================= HANDLE CHANGE ================= */
  const handelvalues = (e, index) => {
    const { name, value } = e.target;
    const updated = [...preemphistory];

    updated[index] = {
      ...updated[index],
      [name]: value
    };

    setNewdata(prev => ({
      ...prev,
      preemphistory: updated
    }));
  };

  /* ================= ADD ROW ================= */
  const AddmoreFields = () => {
    setNewdata(prev => ({
      ...prev,
      preemphistory: [
        ...preemphistory,
        {
          companyname: "",
          designation: "",
          industry: "",
          startdate: "",
          enddate: ""
        }
      ]
    }));
  };

  /* ================= REMOVE ROW ================= */
  const handleRemoveClick = index => {
    setNewdata(prev => ({
      ...prev,
      preemphistory: preemphistory.filter((_, i) => i !== index)
    }));
  };

  return (
    <div className="px-2">
      {preemphistory.map((item, index) => (
        <div key={index}>
          <Row className="mb-2">
            <Col md={4}>
              <Form.Label className="custm-lble">Company Name</Form.Label>
              <Form.Control
                placeholder="Company Name"
                type="text"
                name="companyname"
                value={item.companyname}
                onChange={e => handelvalues(e, index)}
              />
            </Col>

            <Col md={4}>
              <Form.Label className="custm-lble">Designation</Form.Label>
              <Form.Control
                placeholder="Designation"
                type="text"
                name="designation"
                value={item.designation}
                onChange={e => handelvalues(e, index)}
              />
            </Col>

            <Col md={4}>
              <Form.Label className="custm-lble">Industry</Form.Label>
              <Form.Control
                placeholder="Industry"
                type="text"
                name="industry"
                value={item.industry}
                onChange={e => handelvalues(e, index)}
              />
            </Col>
          </Row>

          <Row className="mb-2">
            <Col md={4}>
              <Form.Label className="custm-lble">Start Date</Form.Label>
              <Form.Control
                placeholder="Start Date"
                type="date"
                name="startdate"
                value={item.startdate}
                onChange={e => handelvalues(e, index)}
              />
            </Col>

            <Col md={4}>
              <Form.Label className="custm-lble">End Date</Form.Label>
              <Form.Control
                placeholder="End Date"
                type="date"
                name="enddate"
                value={item.enddate}
                onChange={e => handelvalues(e, index)}
              />
            </Col>
          </Row>

          {index !== 0 && (
            <div
              className="d-flex justify-content-end cursor_P mb-2"
              onClick={() => handleRemoveClick(index)}
            >
              <DeleteIcon className="color-red" />
              <p className="color-remove-red mb-0 ms-1">Remove</p>
            </div>
          )}

          <hr className="mb-3" />
        </div>
      ))}

      <div className="mb-3" onClick={AddmoreFields}>
        <p className="color-text cursor_P">
          <AddCircleIcon style={{ fontSize: "large" }} /> Add More
        </p>
      </div>
    </div>
  );
};

export default PreviuosEmployementHistory;
